import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

export default function OrgGovernanceCard({ orgId }: { orgId: string }) {
    const { t } = useTranslation();
    if (!orgId) return null;

    return (
        <CardStack
            name="orgAdmin"
            title={t('common:organization.governance.title')}
            description={t('common:organization.governance.description')}>
            <OrgLinks organizationId={orgId} variant={'orgGovernance'} />
        </CardStack>
    );
}
